// extracted by mini-css-extract-plugin
export default {"coursesListCon":"styles_coursesListCon__kLN+C","header":"styles_header__EzP0q","title":"styles_title__KT3pw","sHeader":"styles_sHeader__HyoXB","notFound":"styles_notFound__bodTm"};